import {createContext, use} from 'react';

import {sendTrackingData} from '~library/utils/tracking';

const TrackingContext = createContext<
  | {
      track: (data: {dataQaId: string; [key: string]: unknown}) => void;
    }
  | undefined
>(undefined);

function TrackingProvider({children}: {children: React.ReactNode}) {
  function track(data: {dataQaId: string; [key: string]: unknown}) {
    const {dataQaId, ...rest} = data;
    sendTrackingData('click_tracking', {dataQaId: dataQaId, attributes: rest});
  }

  const value = {
    track,
  };

  return <TrackingContext.Provider value={value}>{children}</TrackingContext.Provider>;
}

function useTracking() {
  const context = use(TrackingContext);
  if (context === undefined) {
    throw new Error('useTracking must be used within a TrackingContext');
  }

  return context;
}

export {TrackingProvider, useTracking};
